import copyIconUrl from '../icons/content_copy.svg?url';

/* Debug console — always active, opened via the Debug Log button in the help view */
(function () {
  const logs = [];

  function formatArg(a) {
    if (a instanceof Error) return a.stack || String(a);
    try { return typeof a === 'object' && a !== null ? JSON.stringify(a) : String(a); }
    catch { return '[unserializable]'; }
  }

  function addLog(level, text) {
    const ts = new Date().toISOString().slice(11, 23);
    logs.push({ level, text, ts });
    if (logListEl) appendEntry(level, text, ts);
  }

  ['log', 'warn', 'error'].forEach(level => {
    const orig = console[level];
    console[level] = (...args) => {
      orig.apply(console, args);
      addLog(level, args.map(formatArg).join(' '));
    };
  });

  window.addEventListener('unhandledrejection', e => {
    addLog('error', `Unhandled rejection: ${e.reason?.stack || e.reason}`);
  });

  window.addEventListener('error', e => {
    addLog('error', `Uncaught: ${e.error?.stack || e.message} (${e.filename}:${e.lineno}:${e.colno})`);
  });

  let logListEl = null;

  function appendEntry(level, text, ts) {
    const el = document.createElement('div');
    el.className = `dbg-entry dbg-entry-${level}`;
    el.textContent = `${ts} [${level}] ${text}`;
    logListEl.appendChild(el);
    logListEl.scrollTop = logListEl.scrollHeight;
  }

  function createUI() {
    const pane = document.createElement('div');
    pane.id = 'dbg-pane';
    pane.classList.add('dbg-hidden');

    const header = document.createElement('div');
    header.id = 'dbg-header';

    const title = document.createElement('span');
    title.textContent = 'Console';

    const copyBtn = document.createElement('button');
    copyBtn.id = 'dbg-copy';
    copyBtn.title = 'Copy to clipboard';
    const copyImg = document.createElement('img');
    copyImg.src = copyIconUrl;
    copyBtn.appendChild(copyImg);

    const closeBtn = document.createElement('button');
    closeBtn.id = 'dbg-close';
    closeBtn.title = 'Close';
    closeBtn.textContent = '✕';

    header.appendChild(title);
    header.appendChild(copyBtn);
    header.appendChild(closeBtn);

    logListEl = document.createElement('div');
    logListEl.id = 'dbg-log-list';

    pane.appendChild(header);
    pane.appendChild(logListEl);
    document.body.appendChild(pane);

    function togglePane() {
      const hidden = pane.classList.toggle('dbg-hidden');
      if (!hidden) {
        logListEl.innerHTML = '';
        logs.forEach(({ level, text, ts }) => appendEntry(level, text, ts));
      }
    }

    document.getElementById('dbg-toggle-help').addEventListener('click', togglePane);

    closeBtn.addEventListener('click', () => pane.classList.add('dbg-hidden'));

    let floatBtn = null;
    function showFloatBtn() {
      if (floatBtn) return;
      floatBtn = document.createElement('button');
      floatBtn.id = 'dbg-toggle';
      floatBtn.textContent = 'DEBUG';
      floatBtn.addEventListener('click', togglePane);
      document.body.appendChild(floatBtn);
    }

    if (new URLSearchParams(location.search).get('debug') === 'true') showFloatBtn();

    window.addEventListener('unhandledrejection', showFloatBtn, { once: true });
    window.addEventListener('error', showFloatBtn, { once: true });

    document.getElementById('help-build-date').textContent = `Built: ${__BUILD_DATE__}`;

    copyBtn.addEventListener('click', () => {
      const text = logs.map(({ level, text, ts }) => `${ts} [${level}] ${text}`).join('\n');
      navigator.clipboard.writeText(text).catch(() => {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createUI);
  } else {
    createUI();
  }
})();
